import React from 'react';
import BroadcastersDataContainer from '../../Broadcasters/containers/BroadcastersDataContainer';
import MatchupDataContainer from '../../Matchup/containers/MatchupDataContainer';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';
import BuyTicketsButtonDataContainer from '../../TicketsButton/BuyTicketsButtonDataContainer';
import {
    PreviewGameInfoWrapper,
    Title
} from '../Preview.style';
import useMedia from '@mlb/react-patterns/v4/utils/hooks/useMedia/useMedia';
import GDBREAKPOINTS from '../../themes/breakpoints';

const { SM_REG_MAX } = GDBREAKPOINTS;
const PreviewGameInfo = () => {
    const displayMobileTitles = useMedia({ maxWidth: SM_REG_MAX });
    const followTheGameLabel = useTranslator('label_follow_the_game', 'Follow the Game');
    const probablePitchersLabel = useTranslator('scores_probable_pitchers', 'Probable Pitchers');
    return (
        <>
            {displayMobileTitles && <Title>{followTheGameLabel}</Title>}
            <PreviewGameInfoWrapper>
                {!displayMobileTitles && <Title>{followTheGameLabel}</Title>}

                <BroadcastersDataContainer />
                <BuyTicketsButtonDataContainer />
            </PreviewGameInfoWrapper>
            {displayMobileTitles && <Title>{probablePitchersLabel}</Title>}
            <PreviewGameInfoWrapper>
                {!displayMobileTitles && <Title>{probablePitchersLabel}</Title>}
                <MatchupDataContainer gameStateOverride={'P'}/>
            </PreviewGameInfoWrapper>
        </>
    );
};

export default PreviewGameInfo;
